// extracted by mini-css-extract-plugin
module.exports = {"Menu":"Menu_Menu__3pQ_A","isOpen":"Menu_isOpen__2rYOa","disabled":"Menu_disabled__1AKTY"};